import gql from 'graphql-tag';

// 用户登录
export const login = gql`query login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
        code
        message
        data{
            accessToken
            expiresIn
        }
    }
}`;

export const qrcodeLogin = gql`query qrcodeLogin($code: String!) {
    qrcodeLogin(code: $code) {
        code
        message
        data{
            token
            userId
            unionid
        }
    }
}`;

// 后台账户绑定手机号
export const bindMobile = gql`mutation bindMobile($mobile: String!, $unionid: String!) {
    bindMobile(mobile: $mobile, unionid: $unionid) {
        code
        message
        data
    }
}`;

// 登录
export const adminLogin = gql`query adminLogin($mobile: String!, $password: String!) {
    adminLogin(mobile: $mobile, password: $password) {
        code
        message
        data {
            token
            userId
            unionid
        }
    }
}`;

// 查询权限
export const checkPermission = gql`query checkPermission($userId: Int, $alias: String, $no: String) {
    checkPermission(userId: $userId, alias: $alias, no: $no) {
        code
        message
    }
}`;

// 食堂业务平台获取待办事项
export const messGetAwaitItem = gql`query messGetAwaitItem(
    $userId: Int,
    $pageNumber: Int,
    $pageSize: Int,
    $state: Int,
    $name: String
) {
    messGetAwaitItem(
        userId: $userId,
        pageNumber: $pageNumber,
        pageSize: $pageSize,
        state: $state,
        name: $name
    ) {
        code
        message
        data{
            id
            name
            mobile
            idCard
            unit1
            unit2
            picture
            state
            reason
            remark
        }
        pager{
            totalItems
            pageSize
            currentPage
        }
    }
}`;

// 审批待办事项
export const checkAwaitItem = gql`mutation checkAwaitItem($ids: [Int], $operate: Int, $reason: String) {
    checkAwaitItem(ids: $ids, operate: $operate, reason: $reason) {
        code
        message
    }
}`;

// 获取单位列表
export const getOrganList = gql`query getOrganList($organNo: String, $userId: Int) {
    getOrganList(organNo: $organNo, userId: $userId) {
        code
        message
        data
    }
}`;

// 获取食堂点列表
export const getMessList = gql`query getMessList($organNo: String) {
    getMessList(organNo: $organNo) {
        code
        message
        data{
            id
            name
        }
    }
}`;
// 获取服务人员
export const getServiceUsers = gql`query getServiceUsers($condi: ServiceUsersCondi) {
    getServiceUsers(condi: $condi) {
        code
        message
        data{
            userId
            name
            mobile
            idCard
            unit1
            unit2
            unit3
            avatar
            approver
            date
            messId
            alias
        }
        pager{
            totalItems
            pageSize
            currentPage
        }
    }
}`;

// 获取缴费单列表
export const getMessOrders = gql`query getMessOrders($condi: MessCondi) {
    getMessOrders(condi: $condi) {
        code
        message
        data{
            totalCount
            totalAmout
            totalFee
            totalSettlement
            list{
                orderNo
                type
                name
                idCard
                mess
                amount
                fee
                settlement
                orderTime
                time2
                property
                remark
                flowId
                traceId
                accNo
                accName
                awbkName
                operater
            }
        }
        pager{
            totalItems
            pageSize
            currentPage
        }
    }
}`;

// 人工扣费
export const decuct = gql`mutation decuct(
    $messId: Int,
    $operater: Int,
    $remark: String,
    $count: Int,
    $total: String,
    $list: [DecuctInput],
) {
    decuct(
        messId: $messId,
        operater: $operater,
        remark: $remark,
        count: $count,
        total: $total,
        list: $list
    ) {
        code
        message
    }
}`;

// 人工扣费获取用户列表
export const ducuctGetUserList = gql`query ducuctGetUserList(
    $messId: Int,
    $pageNumber: Int,
    $pageSize: Int,
    $name: String
) {
    ducuctGetUserList(
        messId: $messId,
        pageNumber: $pageNumber,
        pageSize: $pageSize,
        name: $name
    ) {
        code
        message
        data{
            id
            name
            mobile
        }
        pager{
            totalItems
            pageSize
            currentPage
        }
    }
}`;

// 导入模板
export const importTemplate = gql`mutation importTemplate(
    $messId: Int,
    $list: [UserMobileInput]
) {
    importTemplate(
        messId: $messId,
        list: $list
    ) {
        code
        message
        data {
            name
            mobile
            amount
            remark
        }
    }
}`;

// 获取缴费汇总
export const getPaySummary = gql`query getPaySummary($condi: SummaryCondi) {
    getPaySummary(condi: $condi) {
        code
        message
        data{
            info{
                startTime
                endTime
                organName
                organNo
                totalCount
                totalAmount
                totalSettlement
                totalFee
            }
            items{
                organNo
                organName
                messNo
                messName
                count
                amount
                settlement
                fee
            }
            propertys{
                organNo
                organName
                messNo
                messName
                property
                count
                amount
                settlement
                fee
            }
        }
    }
}`;

// 消费记录
export const getMessPayOrder = gql`query getMessPayOrder($condi: PayRecordCondi) {
    getMessPayOrder(condi: $condi) {
        code
        message
        data{
            id
            name
            amount
            mess
            time
            origin
            remark
            operater
            property
        }
        pager{
            totalItems
            pageSize
            currentPage
        }
    }
}`;

// 获取全部食堂
export const getAllMesses = gql`query getAllMesses($messId: Int, $userId: Int, $messName: String) {
    getAllMesses(messId: $messId, userId: $userId, messName: $messName) {
        code
        message
        data{
            id
            name
            isAuto
            messNo
        }
    }
}`;

// 修改错误员工食堂
export const divertBalance = gql`mutation divertBalance(
    $adminId: Int,
    $userId: Int,
    $messId: Int,
    $divertMessId: Int,
    $amount: String
) {
    divertBalance(
        adminId: $adminId,
        userId: $userId,
        messId: $messId,
        divertMessId: $divertMessId,
        amount: $amount
    ) {
        code
        message
    }
}`;

// 获取集团用户所属食堂
export const getUsertype3Messes = gql`query getUsertype3Messes($userId: Int) {
    getUsertype3Messes(userId: $userId) {
        code
        message
        data{
            id
            name
            major
            messNo
        }
    }
}`;

// 修改集团用户所属食堂
export const updateUsertype3Mess = gql`mutation updateUsertype3Mess(
    $messes: [InputMesses],
    $userId: Int
) {
    updateUsertype3Mess(
        messes: $messes,
        userId: $userId
    ) {
        code
        message
    }
}`;

// 获取用户可转移余额食堂
export const getUserDivertMesses = gql`query getUserDivertMesses($userId: Int, $adminId: Int) {
    getUserDivertMesses(userId: $userId, adminId: $adminId) {
        code
        message
        data{
            id
            name
            messNo
        }
    }
}`;

// 生成食堂二维码
export const getMessAlias = gql`query getMessAlias($messId: Int) {
    getMessAlias(messId: $messId) {
        code
        message
        data
    }
}`;

// 设置人员性质
export const updateUserProperty = gql`mutation updateUserProperty(
    $property: Int,
    $userId: Int,
    $messId: Int
) {
    updateUserProperty(
        property: $property,
        userId: $userId,
        messId: $messId
    ) {
        code
        message
    }
}`;

// 食堂价格
export const getMessPrice = gql`query getMessPrice(
    $condi: MessPriceCondi
) {
    getMessPrice(
        condi: $condi
    ) {
        code
        message
        data{
            id
            messName
            property
            type
            startTime
            endTime
            pay
        }
        pager{
            totalItems
            pageSize
            currentPage
        }
    }
}`;

// 获取缴费单列表
export const getTicketList = gql`query getTicketList($condi: TicketCondi) {
    getTicketList(condi: $condi) {
        code
        message
        data{
            id
            ticketNo
            amount
            name
            idCard
            state
            remark
            mess
            balance
            createdAt
        }
        pager{
            totalItems
            pageSize
            currentPage
        }
    }
}`;

// 发行餐券
export const offerTicket = gql`mutation offerTicket(
    $messNo: String,
    $amount: String,
    $userIds: [Int],
    $remark: String,
    $operator: Int
) {
    offerTicket(
        messNo: $messNo,
        amount: $amount,
        userIds: $userIds,
        remark: $remark,
        operator: $operator
    ) {
        code
        message
    }
}`;

// 修改密码
export const updatePassword = gql`mutation updatePassword(
    $userId: Int!,
    $newPassword: String!
) {
    updatePassword(
        userId: $userId,
        newPassword: $newPassword
    ) {
        code
        message
    }
}`;

// 查询消费记录
export const getMessPayRecord = gql`query getMessPayRecord($condi: PayRecordCondi) {
    getMessPayRecord(condi: $condi) {
        code
        message
        data{
            totalCount
            totalAmout
            list{
                id
                name
                idCard
                mess
                amount
                time
                property
                remark
            }
        }
        pager{
            totalItems
            pageSize
            currentPage
        }
    }
}`;

// 查询用户钱包变动记录
export const getUserWalletRecord = gql`query getUserWalletRecord($condi: WalletRecordCondi) {
    getUserWalletRecord(condi: $condi) {
        code
        message
        data{
            id
            mess
            operate
            beforeBalance
            changeAmount
            afterBalance
            time
        }
        pager{
            totalItems
            pageSize
            currentPage
        }
    }
}`;



// WEBPACK FOOTER //
// ./src/graphql/graphql.js